export enum Path {
  AboutApp = '/tietoa-sovelluksesta',
  AcceptTerms = '/hyvaksy-kayttoehdot',
  AccessibilityFeedback = '/vastuullisuus/esteettomyyspalaute',
  AccessibilityStatement = '/saavutettavuusseloste',
  Accountability = '/vastuullisuus',
  AccountInformation = '/asiakastili/omat-tiedot',
  AddressSelection = '/?modal=aloita-tilaus',
  AppPaymentReturn = '/app-payment-return',
  AppWebViewOrderPayment = '/app-payment',
  AppWebViewGiftCardPayment = '/app-gift-card-payment',
  AppMore = '/app-more',
  AppOrderAgain = '/app-order-again',
  B2BGiftCard = '/digilahjakortit-yrityksille',
  Benefits = '/asiakastili/etukoodini',
  Birthdate = '/rekisteroidy/syntymaaika',
  Companies = '/yrityksille',
  Contact = '/ota-yhteytta',
  ContentPages = '/sivut',
  Coupons = '/kupongit',
  EdenredInfo = '/edenred-lounari',
  EPassiReturn = '/auth/epassi',
  FAQ = '/ota-yhteytta#usein-kysyttya',
  Feedback = '/kysely',
  ForgottenPassword = '/unohditko-salasanasi',
  Franchise = '/franchise',
  GiftCard = '/osta-lahjakortti',
  GiftCardSummary = '/lahjakortti-yhteenveto',
  GiftCardOrder = '/lahjakortti/tilaus',
  GiftCardOrderStatus = '/lahjakortti/tilaus/tulos',
  Home = '/',
  Ingredients = '/franchise/raaka-aineet',
  Login = '/kirjaudu',
  LoginWithOtp = '/kirjaudu/otp',
  LoginWithPassword = '/kirjaudu/salasana',
  Loyalty = '/kanta-asiakkuus',
  LoyaltyBenefits = '/asiakastili/edut',
  LoyaltyTerms = '/kanta-asiakasohjelman-sopimusehdot',
  LunchOffer = '/lounas',
  Menu = '/menu',
  NotFound = '/404',
  Offers = '/tarjoukset',
  Order = '/tilaus',
  OrderHistory = '/asiakastili/tilaushistoria',
  OrderHistoryModal = '/menu/tilaa-uudelleen',
  OrderStatus = '/tilaus/tulos',
  PasswordReset = '/vaihda-salasana',
  EmailChange = '/vaihda-sahkoposti',
  PaymentMethods = '/asiakastili/maksutavat',
  PaymentRedirect = '/payment-redirect',
  PrivacyPolicy = '/tietosuojaseloste',
  Register = '/rekisteroidy',
  Restaurants = '/ravintolat',
  Shoppingcart = '/ostoskori',
  Terms = '/ehdot',
  WebShopTerms = '/ehdot/kayttoehdot',
  YoloDeals = '/yolodiilit',
  Licenses = '/ohjelmistolisenssit',
  AppLanding = '/app/landing',
  AppDownload = '/kotipizza-sovellus',
}

type PathWithQuery = `${Exclude<Path, Path.Home>}${'?' | '#' | '/'}${string}`;
export type LocalPath = Path | PathWithQuery;
